/**
 * Rota legada /financeiro/lancamentos/importar-ofx — agora o "Importar OFX" é
 * um slide-over dentro da Lista (mockup Fase 5 V2.2). Redireciona preservando
 * o deep link: ?ofx abre o painel automaticamente.
 */
import React from "react";
import { Navigate } from "react-router-dom";

export default function LancamentoImportarOfx() {
  return <Navigate to="/financeiro/lancamentos?ofx=1" replace />;
}
